import { createContext } from 'react';
// import { useStateManager } from '../hooks/useStateManager';

const defaultState: any = [];

const DashboardContext = createContext(defaultState);

export default DashboardContext;
